import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="relative z-10 px-6 py-12 border-t border-white/10 bg-navy/50 backdrop-blur-sm" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-40">
          {/* Guarantee and Details */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="glass-card p-6 text-sm font-body text-mutedPurple" data-id="element-41">
            <h4 className="text-white font-bold mb-4 font-heading uppercase tracking-wider" data-id="element-42">
              Garantía y Detalles
            </h4>
            <ul className="space-y-2" data-id="element-43">
              <li data-id="element-44">
                <strong className="text-warmWhite" data-id="element-45">
                  Descarga Digital Inmediata:
                </strong>{' '}
                Recibe el enlace en tu email al instante.
              </li>
              <li data-id="element-46">
                <strong className="text-warmWhite" data-id="element-47">Formato:</strong> PDF de alta
                resolución, optimizado para impresión en casa.
              </li>
              <li data-id="element-48">
                <strong className="text-warmWhite" data-id="element-49">Marca:</strong> Small Bright
                Star ⭐
              </li>
            </ul>
            <p className="mt-4 text-xs opacity-75" data-id="element-50">
              Nota: Al ser un producto digital de entrega inmediata, no se
              admiten devoluciones.
            </p>
          </motion.div>

          {/* Postscript */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col justify-center" data-id="element-51">
            <p className="text-lg md:text-xl italic font-body text-warmWhite leading-relaxed" data-id="element-52">
              <span className="text-gold font-bold not-italic mr-2" data-id="element-53">P.D.</span>
              Los niños crecen rápido, pero lo que grabamos en su corazón se
              queda para siempre. Haz que su voz interna sea su mejor aliada.
            </p>
          </motion.div>
        </div>

        <div className="text-center text-sm text-mutedPurple/60 font-body" data-id="element-54">
          <p data-id="element-55">
            © {new Date().getFullYear()} Small Bright Star ⭐. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}